module.exports = __webpack_public_path__ + "img/festival_gift.af407f1d.png";